import { OpportunitySubscriptionState } from './opportunity-subscription-state.interface'

export function createOpportunitySubscriptionState(): OpportunitySubscriptionState {
  return {
    isLoading: false,
    unsubscribeError: null,
    unsubscribeSuccess: null,
  }
}
